import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fetchRecentEvents } from '../../../actions/RecentEventsActions';
import * as Urls from '../../../constants/Urls';
import { isEmpty } from '../../../utils/ramdaUtils';
import Loader from '../../CustomLoader';
import Link from '../../Link';

const RecentEvents = ({ classes, closeDrawer }) => {
  const { data: events, loading } = useSelector((state) => state.recentEvents);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchRecentEvents());
    /* eslint-disable react-hooks/exhaustive-deps */
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      {events.map((item) =>
        isEmpty(item.events) ? null : (
          <div key={item.group} className={classes.drawerSubgroups}>
            <p className={classes.drawerSubgroupTitle}>{item.group}</p>
            <ul className={classes.drawerGroup}>
              {item.events.map((event) => (
                <li
                  key={event.EntityKey}
                  ui-ta={`Event${event.EntityKey}`}
                  className={classes.drawerLinkContainer}
                >
                  <Link
                    className={classes.drawerLink}
                    onClick={closeDrawer}
                    to={{ pathname: Urls.ENTITY_DISPLAY, search: `${event.QueryString}` }}
                  >
                    {event.EntityKey}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        )
      )}
    </>
  );
};

export default RecentEvents;
